import { render } from "./zone-pin.vue?vue&type=template&id=c56c04fa"
import script from "./zone-pin.vue?vue&type=script&lang=js"
export * from "./zone-pin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__